angular
    .module( 'ribytRsvpApp' )
    .directive( 'ticketHeader', function ( $sessionStorage, $rootScope, $state, $sce, variableSubstitution ) {
        return {
            restrict: 'E',
            scope: {
                inviteData: '=',
                invite: '=',
                showHeaderImage: '=',
                showHeaderText: '=',
                showHeaderTitle: '='
            },
            templateUrl: 'views/directives/tickets/ticketHeader.html',
            link: function ( scope, element, attrs ) {
                scope.trustedHtml = function ( plainText ) {
                    return $sce.trustAsHtml( variableSubstitution.doSubstitutions( plainText ) );
                };

                // scope.headerImageSrc = "https://s3-us-west-2.amazonaws.com/ribyt/cdn/images/FFFFFF-0.0.png";
                scope.showTicketBanner = false;
                scope.headerImageSrc = $rootScope.getImagePath( scope.invite, 'experienceID.ticketPageDetails.headerFileID' );
                if ( scope.headerImageSrc !== null && scope.headerImageSrc !== '' ) {
                    scope.showTicketBanner = true;
                }
            }
        };
    } );
